export default "__VITE_ASSET__739a92cd__"